import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useRegion } from '../../context/RegionContext';
import styles from './ClientLogos.module.css';

export const ClientLogos: React.FC<{ industry?: string }> = ({ industry }) => {
  const { t } = useLanguage();
  const { region } = useRegion();

  const isFinance = industry === 'finance';

  let assuranceItems = (region === 'GCC' && t.clientLogos.assuranceItemsGCC)
    ? t.clientLogos.assuranceItemsGCC
    : t.clientLogos.assuranceItems;

  if (isFinance) {
    assuranceItems = ['ISO 27001', 'DORA Compliant', 'BaFin Aligned', 'GDPR Ready'];
  }

  return (
    <section className={styles.logos} aria-label="Strategic Partners">
      <div className={styles.logos__container}>
        <p className={styles.logos__header}>{t.clientLogos.header}</p>

        <div className={styles.logos__track}>
          <div className={styles.logos__marquee}>
            {[...t.clientLogos.enterpriseItems, ...t.clientLogos.enterpriseItems].map((item, index) => (
              <div key={`${item.name}-${index}`} className={styles.logos__partnerItem}>
                <img
                  src={item.logo}
                  alt={item.name}
                  className={styles.logos__partnerImage}
                  width="120"
                  height="40"
                />
              </div>
            ))}
          </div>
        </div>

        <div className={styles.logos__assurance}>
          <p className={styles.logos__subheader}>{t.clientLogos.assuranceTitle}</p>
          <div className={styles.logos__grid}>
            {assuranceItems.map((label: string) => (
              <div key={label} className={`${styles.logos__pill} ${styles['logos__pill--assurance']}`}>
                {label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;
